import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgInfoAlt = function SvgInfoAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M12 0C5.39 0 0 5.39 0 12s5.39 12 12 12 12-5.39 12-12S18.61 0 12 0zm0 21.984c-5.531 0-9.984-4.5-9.984-9.984 0-5.531 4.5-9.984 9.984-9.984s9.984 4.5 9.984 9.984A9.963 9.963 0 0112 21.984z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M12 10.031H9.984a.99.99 0 00-.984.985c0 .515.469.984.984.984h.985v6h2.015v-6.984A.961.961 0 0012 10.03zM12 8.016a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M14.016 18.984H10.03A.99.99 0 019.047 18c0-.516.469-.984.984-.984h3.985A.99.99 0 0115 18c0 .516-.469.984-.984.984z"
  }));
};

export default SvgInfoAlt;